import { render, staticRenderFns } from "./PreAreaForm.vue?vue&type=template&id=73d8aa69&"
import script from "./PreAreaForm.vue?vue&type=script&lang=js&"
export * from "./PreAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d8aa69')) {
      api.createRecord('73d8aa69', component.options)
    } else {
      api.reload('73d8aa69', component.options)
    }
    module.hot.accept("./PreAreaForm.vue?vue&type=template&id=73d8aa69&", function () {
      api.rerender('73d8aa69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/modules/PreAreaForm.vue"
export default component.exports